
import { computed, defineComponent, onMounted, ref } from 'vue';
import ArchiveCard from '@/components/ArchiveCard.vue';
import Pagination from '@/components/Pagination.vue';
import { IQuiz } from '@/types/quiz';
import { routeNewDocument } from '@/core/constants';
import { getArchivedQuizApi, searchQuizApi, unArchiveQuizApi } from '@/api/QuizApi';
// import { useRouter } from 'vue-router';
import QuizFilters from '@/components/QuizFilters.vue';
import { key } from '@/store';
import { useStore } from 'vuex';
import SearchInputHeader from '@/components/SearchInputHeader.vue';
import TabsComponent from '@/components/Tabs.vue';
import { CtaType } from '@/types/CtaType';
import useBusinessFunctionId from '@/hooks/useBusinessFunctionId';

export default defineComponent({
  name: 'ArchivePage',
  components: {
    TabsComponent,
    SearchInputHeader,
    ArchiveCard,
    Pagination,
    QuizFilters,
  },
  setup() {

    const tabName = ref<CtaType>(CtaType.EPX);

    const tabs = [
      { name: CtaType.EPX, label: 'EPX' },
      { name: CtaType.EMS, label: 'EMS' },
    ]

    const onTabChange = (name: string) => {
      tabName.value = name as CtaType;
      getQuizzes(1, name as CtaType);
    }


    const store = useStore(key);
    const searchValue = computed(() => store.state['getQuizPayload'].name);
    const getQuizPayload = computed(() => store.state.getQuizPayload);
    const rNewDocument = ref(routeNewDocument);
    const documents = ref<IQuiz[]>([]);
    // const router = useRouter();
    const pageMeta = ref({
      current_page: null,
      last_page: null,
      from: null,
      to: null,
      total: null,
    });
    const searchName = ref('');

    const businessFunctionId = useBusinessFunctionId();

    const handleQuizResponse = (res: any) => {
      documents.value = res.data.data;
      pageMeta.value = res.data.meta;
    };

    const getQuizzes = (page = 1, cta_type: CtaType) => {
      getArchivedQuizApi(page, cta_type).then(handleQuizResponse);
    };
    onMounted(() => {
      getQuizzes(1, tabName.value);
    });
    const handleSearch = (searchInputValue: string): void => {
      searchName.value = searchInputValue;
      searchQuizApi({
        ...getQuizPayload.value,
        page: 1,
        name: searchInputValue,
        show_only_archived: true,
      }).then(handleQuizResponse);
    };
    const navigateToPage = (page: number) => {
      getQuizzes(page, tabName.value);
    };

    const unarchiveQuiz = (quizId: number) => {
      unArchiveQuizApi(quizId).then(() => {
        getQuizzes(pageMeta.value.current_page || 1, tabName.value);
      });
    };

    const haveItems = computed(() => documents.value.length);

    const onFilterChange = (payload: any) => {
      searchQuizApi({
        ...getQuizPayload.value,
        page: 1,
        name: searchName.value,
        ...payload,
        show_only_archived: true,
      }).then(handleQuizResponse);
    }
    return {
      documents,
      rNewDocument,
      handleSearch,
      navigateToPage,
      unarchiveQuiz,
      pageMeta,
      haveItems,
      onFilterChange,
      businessFunctionId,

      searchValue,

      tabs,
      onTabChange,
      tabName,
    };
  },
});
